module.exports = "<div class=\"check-off-history\">\n\t<h3>History</h3>\n\t\n\t<check-off-history-item *ngFor=\"let item of historyItems | reverse\" [item]=\"item\"></check-off-history-item>\n\t\n\t<div *ngIf=\"!historyItems || !historyItems.length\">Nothing checked off in the last 24 hours</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/checkoffs/check-off-history/check-off-history.component.html
// module id = ./src/app/checkoffs/check-off-history/check-off-history.component.html
// module chunks = 0